exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table.table-bordered td,.table.table-bordered th{font-size:13px!important;vertical-align:middle!important}[dir] .table.table-bordered td,[dir] .table.table-bordered th{padding:2px 4px!important}.table.table-bordered input.form-control{height:20px!important;font-size:13px!important}[dir] .table.table-bordered input.form-control{padding:2px 6px!important}[dir] .table.table-bordered{margin-bottom:0}.btn.btn-danger.btn-sm,.btn.btn-sm{font-size:12px!important}[dir] .btn.btn-danger.btn-sm,[dir] .btn.btn-sm{padding:2px 8px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19006b80","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/subscription/subscription.vue
// module id = 1470
// module chunks = 0